import FindControlViewState from '../store/schema/FindControlViewState';
import FindRecipientPersonaType from '../store/schema/FindRecipientPersonaType';
import transactionCompleted from 'owa-controls-findpeople-feedback-manager/lib/actions/transactionCompleted';
import personaTypeMap from 'owa-controls-findpeople-feedback-manager/lib/utils/PersonaTypeMap';
import { OwaDate } from 'owa-datetime';

function getFindPeopleResultsAsEntityIds(findPeopleResults: FindRecipientPersonaType[]): string[] {
    let entityIds = [];

    if (findPeopleResults) {
        findPeopleResults.forEach((result, index) => {
            // we should use ID whenever it's available
            entityIds[index] =
                result.Id || result.EmailAddress.EmailAddress || result.EmailAddress.Name;
        });
    }

    return entityIds;
}

/**
 * Adds a relevance api transaction complete feedback
 */
export default function addTransactionComplete(
    recipientWellViewState: FindControlViewState,
    transactionRequestTime: OwaDate,
    transactionId: string
) {
    let personaTypeList = [];
    if (recipientWellViewState.findResultSet && recipientWellViewState.findResultSet.length > 0) {
        recipientWellViewState.findResultSet.forEach(suggestion => {
            personaTypeList.push(personaTypeMap[suggestion.PersonaTypeString]);
        });
    }

    let context = {
        Action: 'Type Down',
    };

    transactionCompleted(
        recipientWellViewState.findPeopleFeedbackManager,
        recipientWellViewState.queryString,
        getFindPeopleResultsAsEntityIds(recipientWellViewState.findResultSet),
        transactionId,
        transactionRequestTime,
        context,
        personaTypeList
    );
}
